module.exports = __webpack_public_path__ + "static/media/blockx-loading.9c39fce9.svg";